var map = {
	"./01Jungle.m4a": "./src/Containers/Story/StoryScripts/bhana-ma-ko-hun/assets/background/01Jungle.m4a",
	"./Bhaisi song (1).m4a": "./src/Containers/Story/StoryScripts/bhana-ma-ko-hun/assets/background/Bhaisi song (1).m4a",
	"./City music horse.m4a": "./src/Containers/Story/StoryScripts/bhana-ma-ko-hun/assets/background/City music horse.m4a",
	"./Horse song.m4a": "./src/Containers/Story/StoryScripts/bhana-ma-ko-hun/assets/background/Horse song.m4a",
	"./Jungle (1).m4a": "./src/Containers/Story/StoryScripts/bhana-ma-ko-hun/assets/background/Jungle (1).m4a",
	"./My Song 20.m4a": "./src/Containers/Story/StoryScripts/bhana-ma-ko-hun/assets/background/My Song 20.m4a",
	"./My Song 43.m4a": "./src/Containers/Story/StoryScripts/bhana-ma-ko-hun/assets/background/My Song 43.m4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Story/StoryScripts/bhana-ma-ko-hun/assets/background sync recursive ^\\.\\/.*$";